var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box",attrs:{"id":"container"}},[_c('div',{attrs:{"layout":"row top-left"}},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }